import { uniqueId } from 'lodash-es';
import { IconAperture, IconCurrentLocation, IconOctahedron, IconSubtask, IconCertificate, IconAsset, IconCloud } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { AppState } from 'src/store/Store';
import { MdOutlinePrivacyTip } from 'react-icons/md';

interface MenuitemsType {
  [x: string]: any;
  id?: string;
  navlabel?: boolean;
  subheader?: string;
  title?: string;
  icon?: any;
  href?: string;
  children?: MenuitemsType[];
  chip?: string;
  chipColor?: string;
  variant?: string;
  external?: boolean;
  _name?: string;
}

const mock_chip_counts: any = [
  // { title: 'Targets', count: 6 },
  // { title: 'Results', count: 3 },
  // { title: 'Overview', count: 1 },
  // { title: 'Ports', count: 2 },
  // { title: 'Assets', count: 1 },
  // { title: 'Subdomains', count: 1 },
  // { title: 'Technologies', count: 1 },
  // // { title: 'Network and Protocols', count: 1 },
  // { title: 'DNS', count: 1 },
  // { title: 'Certificates', count: 1 },
  // // { title: 'Vuln. and Threat Intelligence', count: 1 },
  // { title: 'Headers', count: 1 },
  // { title: 'Vulnerabilities', count: 1 },
  // { title: 'Secrets', count: 1 },
  // { title: 'Malicious Content', count: 0 },
  // // { title: 'Resource and Protection', count: 1 },
  // { title: 'Subdomain Takeover', count: 1 },
  // { title: 'Hidden Paths and Files', count: 1 },
  // // { title: 'Cloud and Infrastructure', count: 1 },
  // { title: 'Cloud Environment', count: 1 },
  // // { title: 'Privacy', count: 1 },
  // { title: 'Third-Parties and Trackers', count: 1 },
  // { title: 'Ports', count: 1 },
  // { title: 'Requests', count: 1 },
  // { title: 'Target Settings', count: 1 },
];
// CONDITIONAL STRUCTURE:
// eslint-disable-next-line no-constant-condition
/* ...(true // app_Rx.domainId
    ? [ {},{},... ]
    : []), 
  */

const Menuitems = () => {
  const app_Rx = useSelector((state: AppState) => state.appGeneralReducer);

  function getChipCounts(itemName: string) {
    const num = mock_chip_counts?.find((i: any) => i.title === itemName)?.count || 0;
    return num;
  }

  const menudata: MenuitemsType = [
    // { _name: 'Space' },
    // { This is discarded since it is required to have as a direct popup caller button instead of a new page.
    //   id: uniqueId(),
    //   title: 'Add Domain',
    //   chip: getChipCounts('Add Domain'),
    //   icon: IconCirclePlus,
    //   href: '/add-new',
    //   children: [],
    // },
    {
      id: uniqueId(),
      title: 'Targets',
      chip: getChipCounts('Targets'),
      icon: IconCurrentLocation,
      href: '/targets',
      children: [],
    },
    { _name: 'Space' },
    {
      id: uniqueId(),
      title: 'Results',
      chip: getChipCounts('Results'),
      icon: IconAperture,
      href: '/results',
      children: [
        {
          id: uniqueId(),
          title: 'Overview',
          chip: getChipCounts('Overview'),
          href: '/summary',
        },
        {
          id: uniqueId(),
          title: 'CRS Assessments',
          chip: getChipCounts('CRS Assessments'),
          href: '/cybersecurity-risk-score',
        },
      ],
    },
    { _name: 'Divider' },
    {
      id: uniqueId(),
      title: 'Assets',
      chip: getChipCounts('Assets'),
      icon: IconAsset,
      href: '/assets',
      children: [
        {
          id: uniqueId(),
          title: 'Subdomains',
          chip: getChipCounts('Subdomains'),
          href: '/assets/subdomains',
          availablePlans: ['Full'],
        },
        {
          id: uniqueId(),
          title: 'Technologies',
          chip: getChipCounts('Technologies'),
          chipColor: 'success',
          href: '/assets/technologies',
        },
        {
          id: uniqueId(),
          title: 'WAF',
          chip: getChipCounts('WAF'),
          chipColor: 'secondary',
          href: '/assets/waf',
        },
      ],
    },
    { _name: 'Divider' },
    {
      id: uniqueId(),
      title: 'Network and Protocols',
      chip: getChipCounts('Network and Protocols'),
      icon: IconCertificate,
      href: '/network',
      children: [
        {
          id: uniqueId(),
          title: 'DNS',
          // chip: getChipCounts('DNS'),
          chip: getChipCounts('DNS'),
          chipColor: 'secondary',
          href: '/network/dns',
        },
        {
          id: uniqueId(),
          title: 'Certificates',
          chip: getChipCounts('Certificates'),
          chipColor: 'secondary',
          href: '/network/certificates',
        },
        {
          id: uniqueId(),
          title: 'Ports',
          chip: getChipCounts('Ports'),
          chipColor: 'success',
          href: '/network/ports',
        },
      ],
    },
    { _name: 'Divider' },
    {
      id: uniqueId(),
      title: 'Vuln. and Threat Intelligence',
      chip: getChipCounts('Vuln. and Threat Intelligence'),
      icon: IconOctahedron,
      href: '/threat',
      children: [
        {
          id: uniqueId(),
          title: 'Headers',
          chip: getChipCounts('Headers'),
          href: '/threat/headers',
        },
        {
          id: uniqueId(),
          title: 'Vulnerabilities',
          chip: getChipCounts('Vulnerabilities'),
          href: '/threat/vulnerabilities',
        },
        {
          id: uniqueId(),
          title: 'Secrets',
          chip: getChipCounts('Secrets') || 'Beta',
          chipColor: undefined,
          href: '/threat/secrets',
          availablePlans: ['Standard', 'Full'],
        },
        {
          id: uniqueId(),
          title: 'Static Code Analysis',
          chip: getChipCounts('Static Code Analysis'),
          chipColor: 'secondary',
          href: '/threat/static-code-analysis',
          availablePlans: ['Standard', 'Full'],
        },
        {
          id: uniqueId(),
          title: 'Malicious Content',
          chip: getChipCounts('Malicious Content') || 'Beta',
          chipColor: undefined,
          href: '/threat/malicious',
          availablePlans: ['Standard', 'Full'],
          // href: '',
        },
      ],
    },
    { _name: 'Divider' },
    {
      id: uniqueId(),
      title: 'Resource and Protection',
      chip: getChipCounts('Resource and Protection'),
      icon: IconSubtask,
      href: '/protection',
      children: [
        {
          id: uniqueId(),
          title: 'Sensitive Files & Paths',
          chip: getChipCounts('Sensitive Files & Paths'),
          chipColor: 'secondary',
          href: '/protection/sensitive-resources',
          availablePlans: ['Standard', 'Full'],
        },
        {
          id: uniqueId(),
          title: 'Subdomain Takeover',
          chip: getChipCounts('Subdomain Takeover'),
          chipColor: 'secondary',
          href: '/protection/subdomain-takeover',
          availablePlans: ['Full'],
        },
        // {
        //   id: uniqueId(),
        //   title: 'Hidden Paths and Files',
        //   chip: getChipCounts('Hidden Paths and Files') || 'Soon',
        //   chipColor: 'success',
        //   // href: '/protection/hidden-paths-files',
        //   href: '',
        // },
      ],
    },
    // { _name: 'Divider' },
    // {
    //   id: uniqueId(),
    //   title: 'Cloud and Infrastructure',
    //   chip: getChipCounts('Cloud and Infrastructure'),
    //   icon: IconCloud,
    //   href: 'cloud-infra',
    //   children: [
    //     {
    //       id: uniqueId(),
    //       title: 'Cloud Environment',
    //       chip: getChipCounts('Cloud Environment') || 'Soon',
    //       chipColor: 'success',
    //       href: '#',
    //     },
    //   ],
    // },
    { _name: 'Divider' },
    {
      id: uniqueId(),
      title: 'Privacy',
      href: 'privacy',
      icon: MdOutlinePrivacyTip,
      children: [
        {
          id: uniqueId(),
          title: 'Third-Parties and Trackers',
          chip: getChipCounts('Third-Parties and Trackers'),
          href: '/privacy/requests',
        },
      ],
    },
    { _name: 'Divider' },
    // { //^ Decided to display AddNewDomainDialog popup instead of a page.
    //   id: uniqueId(),
    //   title: 'Target Settings',
    //   icon: IconSettings,
    //   href: '/target-settings/target',
    //   children: [],
    // },
    // { _name: 'Divider' },
    // {
    //   id: uniqueId(),
    //   title: 'DEV',
    //   icon: IconBackhoe,
    //   href: '/development/',
    //   children: [
    //     {
    //       id: uniqueId(),
    //       title: 'My Dev Components',
    //       icon: IconPoint,
    //       href: '/development/my-devcomps',
    //     },
    //     {
    //       id: uniqueId(),
    //       title: 'Invoice',
    //       icon: IconPoint,
    //       href: '/development/invoice',
    //     },
    //     {
    //       id: uniqueId(),
    //       title: 'Choose Plan',
    //       icon: IconPoint,
    //       href: '/user/plan',
    //     },
    //   ],
    // },
  ];
  return menudata;
};

export default Menuitems;
